module.exports = __webpack_public_path__ + "img/121.7.b60e3f4c.png";